import { useState } from 'react';
import { useFilterContext, useDerivedNetworkContext } from '@/context';
import { DownloadButtonEcho } from '@/components/drawers/DownloadButton/DownloadButtonEcho';
import useNewDownloadDrawersEnabled from '@/hooks/useNewDownloadDrawersEnabled';
import { CONTENT_PERFORMANCE_PAGE } from '@/utils/constants';
import { mixpanelTrack } from '@/utils/mixpanelUtils/asyncMixpanel';
import { MIXPANEL_EVENT, RevenueDashboardWidget } from '@/utils/mixpanelUtils/events';
import ContentPerformanceDownloadDrawer from './ContentPerformanceDownloadDrawer';
import ContentPerformanceDownloadDrawerEcho from './ContentPerformanceDownloadDrawerEcho';

/**
 * Opens the content performance CSV download drawer (Echo).
 */
const ContentPerformanceDownloadDrawerTriggerEcho = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const isNewDownloadDrawerEnabled = useNewDownloadDrawersEnabled();
  const { selectedNetworks, shows } = useDerivedNetworkContext();
  const { filters } = useFilterContext();
  const DownloadDrawer = isNewDownloadDrawerEnabled
    ? ContentPerformanceDownloadDrawer
    : ContentPerformanceDownloadDrawerEcho;

  const handleOpen = () => {
    setIsOpen(true);
    mixpanelTrack(MIXPANEL_EVENT.contentPerformance.downloadDrawer.opened, {
      widget: RevenueDashboardWidget.ContentPerformanceDownloadDrawer,
      page: CONTENT_PERFORMANCE_PAGE,
    });
  };

  return (
    <>
      <DownloadButtonEcho onClick={handleOpen} />
      {isOpen && (
        <DownloadDrawer
          isOpen={isOpen}
          handleClose={() => setIsOpen(false)}
          selectedNetworks={selectedNetworks}
          globalFilters={filters}
          shows={shows}
        />
      )}
    </>
  );
};

export default ContentPerformanceDownloadDrawerTriggerEcho;
